module.exports = __webpack_public_path__ + "img/movImg.c81ab514.png";